import { api } from './api';

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIntercomUserJwt: build.query<{ token: string; expiresAt: string }, void>({
      query: () => ({
        url: 'auth/intercom-user-jwt',
        method: 'GET',
      }),
      providesTags: ['IntercomUserJwt'],
      // Server guarantees >=120s validity on any served token; keep cached data
      // for the full 600s token lifetime so quiet sessions don't re-fetch unnecessarily.
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useGetIntercomUserJwtQuery } = authApi;
